
import { i18nText } from '@/locales';

import { Component, Vue } from 'vue-property-decorator';
import { AuthStore } from '@/store/modules/Auth';
import Api from '@/repository/api';
import { changeCompany } from '@/plugins/Http';

// Ant-Design localization
import { ConfigProvider } from 'ant-design-vue';
import en_US from 'ant-design-vue/lib/locale-provider/en_US';
import moment from 'moment';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import ru_RU from 'ant-design-vue/lib/locale-provider/ru_RU';
import 'moment/locale/ru';

@Component({
    components: {
        'a-config-provider': ConfigProvider,
    },
})
export default class App extends Vue {
    ready = false;
    companyRequired = false;
    companies: Array<{id: number; name: string}> = [];
    bootError = '';

    selectCompany(id: number): void { changeCompany(id); }
    async openRegistration(): Promise<void> { this.companyRequired = false; await this.$router.push('/register'); this.ready = true; }
    async exit(): Promise<void> { sessionStorage.removeItem('company_id'); await AuthStore.logout(); }
    data(): any {
        return {
            ru_RU, en_US,
        };
    }
    async mounted(): Promise<void> {
        moment.locale(this.$i18n.locale); dayjs.locale(this.$i18n.locale);
        await new Promise<void>(resolve => this.$router.onReady(resolve));
        if (this.$route.path === '/register') { this.ready = true; return; }
        if (!Vue.auth.token()) { this.ready = true; return; }
        try {
            const response = await Api.get('/company/get');
            this.companies = response.data.data;
            if (response.data.system_admin) sessionStorage.removeItem('company_id');
            const selected = Number(sessionStorage.getItem('company_id'));
            if (selected && !this.companies.some(company => company.id === selected)) {
                sessionStorage.removeItem('company_id');
                sessionStorage.removeItem('salon_id');
                sessionStorage.removeItem('userData');
            }
            if (!response.data.system_admin && !sessionStorage.getItem('company_id')) {
                if (this.companies.length === 1) sessionStorage.setItem('company_id', String(this.companies[0].id));
                else { this.companyRequired = true; return; }
            }
            const profile = await Api.get('/user');
            const user = profile.data;
            user.CompleteRoles = user.roles.map((role: {code: string}) => role.code);
            Vue.auth.user(user);
            sessionStorage.setItem('userData', JSON.stringify(user));
            await AuthStore.fetchManual();
            this.$store.commit('changeSalon', user.studios || 0);
            this.ready = true;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                await Vue.auth.logout({makeRequest: false, redirect: '/auth/login'});
                this.ready = true;
            } else this.bootError = i18nText("Не удалось загрузить компанию. Обновите страницу или обратитесь в поддержку.");
        }
    }
}
